/** @typedef {'auto' | 'manual' | 'both'} DriverLicenseType */
/** @typedef {'auto' | 'manual'} BusType */

export const DRIVER_LICENSE_OPTIONS = [
  { value: 'auto', label: 'Automatic only' },
  { value: 'manual', label: 'Manual only' },
  { value: 'both', label: 'Automatic & manual' },
];

export const BUS_TYPE_OPTIONS = [
  { value: 'auto', label: 'Automatic' },
  { value: 'manual', label: 'Manual' },
];

/**
 * @param {DriverLicenseType | null | undefined} license
 * @param {BusType | null | undefined} busType
 */
export function licenseCanDrive(license, busType) {
  if (!license || !busType) return false;
  if (license === 'both') return true;
  return license === busType;
}

export const ASSIGNMENT_LABELS = {
  confirmed: 'Confirmed on bus',
  waitlisted: 'Waitlisted — driver will confirm when a seat opens',
  not_going: 'Not going',
};

/** @param {string | null | undefined} licenseType */
export function licenseTypeLabel(licenseType) {
  const opt = DRIVER_LICENSE_OPTIONS.find((o) => o.value === licenseType);
  return opt?.label || licenseType || '—';
}
